import type { ReactElement } from 'react';

const SKELETON_ROWS = 4;

/** 첫 로딩 자리표시 — 표와 같은 높이(썸네일 칸 포함)의 회색 줄. 문구는 화면낭독기에만 읽힌다. */
export const MyQuoteListSkeleton = (): ReactElement => (
  <div>
    <p role="status" className="sr-only">
      내 견적을 불러오는 중입니다.
    </p>
    <div aria-hidden className="border-t border-foreground">
      {Array.from({ length: SKELETON_ROWS }, (_, index) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: 고정 개수의 장식 줄이다.
          key={index}
          className="flex items-center gap-6 border-b border-foreground/10 py-5 sm:py-6"
        >
          <div className="h-4 w-20 animate-pulse bg-muted/70" />
          <div className="flex flex-1 items-center gap-3 sm:gap-4">
            <div className="size-11 shrink-0 animate-pulse bg-muted/70 sm:size-14" />
            <div className="h-4 flex-1 animate-pulse bg-muted/70" />
          </div>
          <div className="h-4 w-24 animate-pulse bg-muted/70" />
        </div>
      ))}
    </div>
  </div>
);
